module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zI7z5t/tc-custom/9780545539364.jpg?1718183630357",
      "alt": "This image is the cover for the book Forevermore"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Forevermore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this paranormal romance, an American teen’s stepfather relocates her family to a haunted Scottish castle where she finds mystery and forbidden love.")]), _c('br'), _c('br'), _vm._v("Ivy Calhoun’s life has been turned upside down. Her new stepdad has uprooted Ivy and her mom, bringing them to live in an actual castle in the misty Scottish countryside. There are stone-faced servants and shadowy corridors, and the ancient walls seem full of secrets. Ivy is at once frightened and intrigued."), _c('br'), _c('br'), _vm._v("Especially when she meets Logan, a gorgeous, elusive ghost who has haunted the castle grounds for decades. Ivy is immediately drawn to him . . . but Logan is not the only spirit around. Something dark and deadly is afoot, and soon Ivy finds herself in mortal danger. Is Logan exactly what he seems? Could his mysterious past be tied to Ivy’s present? And can Ivy stop herself from falling in love with him?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cindy Miles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" Cindy Miles is a successful author of romance novels for adults. She grew up on the salt marshes of the Vernon River in Savannah, Georgia. After first visiting Scotland's desolate moors and haunting castle ruins, the country and its wild history fast became her muse. Cindy still lives in Savannah, and frequents the crumbling fortresses of Scotland and England as often as possible. FOREVERMORE is her first novel for teens. You can visit Cindy online at www.cindy-miles.com. ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Scholastic\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0